import meta from './meta.js'

export function setFacebookURL(id) {
  const page = meta.find(s => s.id === id)
  return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(page.url)}`
}
export function setTwitterURL(id) {
  const page = meta.find(s => s.id === id)
  return `https://twitter.com/intent/tweet?text=${encodeURIComponent(page.tw)}`
}
export function setWhatsAppURL(id) {
  const page = meta.find(s => s.id === id)
  return `whatsapp://send?text=${encodeURIComponent(page.wa)}`
}
